export default __webpack_public_path__ + "static/media/fallback-void.5bddae5e.svg";